var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import { Icon, invokeEventHandler, StackLayout, useActiveThemeVariation } from '@wemogy/reactbase';
import { MapContainer, TileLayer, Popup } from 'react-leaflet';
import './web/MapImplementation.css';
import Marker from './web/marker/Marker';
import GeolocationService from '../../../dataLayer/services/GeolocationService';
function loadCss() {
    // Get HTML head element
    var head = window.document.getElementsByTagName('HEAD')[0];
    // Create new link Element
    var link = window.document.createElement('link');
    // set the attributes for link element
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
    // Append link element to HTML head
    head.appendChild(link);
}
var MapImplementation = function (props) {
    var center = props.center, markers = props.markers, disableFlyAnimation = props.disableFlyAnimation, onCurrentPositionRequested = props.onCurrentPositionRequested, loadingIndicatorRenderer = props.loadingIndicatorRenderer;
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.map; });
    var _a = __read(useState(undefined), 2), mapRef = _a[0], setMapRef = _a[1];
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(useState((markers === null || markers === void 0 ? void 0 : markers.length) ? 7 : 18), 1), zoom = _c[0];
    useEffect(loadCss, []);
    console.log('markers', markers);
    useEffect(function () {
        if (!(markers === null || markers === void 0 ? void 0 : markers.length) || !mapRef) {
            return;
        }
        var markerOne = markers[0];
        mapRef.flyTo({ lat: markerOne.position.latitude, lng: markerOne.position.longitude }, 18, { animate: !disableFlyAnimation });
    }, [markers, mapRef, disableFlyAnimation]);
    var handleGetCurrentLocationPress = useCallback(function () {
        setLoading(true);
        GeolocationService.getCurrentPosition().then(function (position) {
            setLoading(false);
            if (!position) {
                return;
            }
            invokeEventHandler(onCurrentPositionRequested, position);
        })
            .catch(function () {
            setLoading(false);
        });
    }, []);
    return (React.createElement(StackLayout, { stretch: true, width100: true },
        React.createElement(MapContainer, { whenCreated: setMapRef, center: [center.latitude, center.longitude], zoom: zoom, scrollWheelZoom: true, markerZoomAnimation: true },
            React.createElement(TileLayer, { attribution: '\u00A9 <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
            (markers === null || markers === void 0 ? void 0 : markers.map(function (marker) { return (React.createElement(Marker, { position: marker.position, onPositionChanged: marker.onPositionChanged, icon: marker.customIcon || activeThemeVariation.markerIcon, iconVariation: activeThemeVariation.markerIconVariation },
                React.createElement(Popup, null,
                    "A pretty CSS3 popup. ",
                    React.createElement("br", null),
                    " Easily customizable."))); })) || null),
        React.createElement(StackLayout, { positionAbsolute: true, bottom: true, left: true, zIndex: 990, onPress: handleGetCurrentLocationPress },
            React.createElement(Icon, { icon: activeThemeVariation.gpsPositionIcon, variationKey: activeThemeVariation.gpsPositionIconVariation })),
        loading && loadingIndicatorRenderer ? (React.createElement(StackLayout, { vCenter: true, hCenter: true, zIndex: 991, positionAbsoluteFill: true, backgroundColor: { custom: 'rgba(255,255,255,0.5)' } }, loadingIndicatorRenderer())) : null));
};
export default MapImplementation;
//# sourceMappingURL=MapImplementation.js.map